import * as SSO from "@10x/sso";
import { ProjectProperty, PropertiesWithProject } from "@eres/ejari-api/Entity/LeasedProperties";
import {upperFirst} from "lodash";
import _ from "lodash";

export function pascalizeKeys (obj: any) : any {
	if (Array.isArray(obj)) {
		return obj.map(v => pascalizeKeys(v));
	} else if (obj !== null && obj.constructor === Object) {
		return Object.keys(obj).reduce(
			(result, key) => ({
				...result,
				[upperFirst(key)]: pascalizeKeys(obj[key]),
			}),
			{},
		);
	}
	return obj;
};

export function OwnerLeaseCountResponse(actualResponse: any): any {
	if (actualResponse.response && actualResponse.response.propertiesPerTypes && actualResponse.response.propertiesPerTypes.length > 0) {
		let pId = SSO.getParticipantID();
		let responseObj: any[] = [] ;
		actualResponse.response.propertiesPerTypes.map((item: any) => {
			let obj = {
				"Identity": item.identity,
				"PropertyTypeId": item.propertyTypeId,
				"ParticipantId": pId,
				"PropertyTypeNameEn": item.propertyTypeNameEn,
				"PropertyTypeNameAr": item.propertyTypeNameAr,
				"TotalLeasedPropertiesPerType": item.totalLeasedPropertiesPerType,
				"TotalPropertiesPerType": item.totalPropertiesPerType,
			};
			responseObj.push(obj);
		});
		return {
			"Code": "0",
			"Message": "NoErrors",
			"Response": responseObj,
		};
	} else {
		return {
			"Code": "0",
			"Message": "NoErrors",
			"Response": [],
		};
	}
}

export function  GetPropertiesWithProjectsResponse(actualResponse: any): any {
	if (actualResponse.response && actualResponse.response.projects && actualResponse.response.projects.length > 0) {
		return {
			"Code": "0",
			"Message": "NoErrors",
			"Response": pascalizeKeys(actualResponse.response.projects),
		};
	} else {
		return {
			"Code": "0",
			"Message": "NoErrors",
			"Response": [],
		};
	}
}

export function GetProjectPropertiesResponse(actualResponse: any): any {
	if (actualResponse.response && actualResponse.response.properties) {
		return {
			"Code": "0",
			"Message": "NoErrors",
			"Response": pascalizeKeys(actualResponse.response.properties),
		};
	} else {
		return {
			"Code": "0",
			"Message": "NoErrors",
			"Response": [],
		};
	}
}

export function GetMobilePropertyDetailsResponse(actualResponse: any): any {
	if (actualResponse.response && actualResponse.response.property) {
		return {
			"Code": "0",
			"Message": "NoErrors",
			"Response": pascalizeKeys(actualResponse.response.property),
		};
	} else {
		return {
			"Code": "0",
			"Message": "NoErrors",
			"Response": [],
		};
	}
}

export function GetContractPropertiesWithProjectsResponse(actualResponse: any): any {
	if (actualResponse.response && actualResponse.response.contracts) {
		return {
			"Code": "0",
			"Message": "NoErrors",
			"Response": pascalizeKeys(actualResponse.response.contracts),
		};
	} else {
		return {
			"Code": "0",
			"Message": "NoErrors",
			"Response": [],
		};
	}
}
